module.exports = __webpack_public_path__ + "img/farzana-christopher-83.6aa99cb3.jpg";